<template>
  <span class="dot" :style="bgColor"></span>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  },
  computed: {
    bgColor () {
      return `background-color: ${this.color};`
    }
  }
}
</script>

<style lang="scss">
    .dot {
        display: inline-block;
        width: 26px;
        height: 26px;
        border-radius: 50%;
    }
</style>
